import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import * as DialogActions from '../actions/Dialog';
import * as PasswordActions from '../actions/Password';
import ChangePasswordForm from '../components/ChangePasswordForm';

const selector = formValueSelector('changePasswordForm');

const mapStateToProps = (state: any) => {
  const oldPassword = selector(state, 'oldPassword');
  const newPassword = selector(state, 'newPassword');
  const confirmation = selector(state, 'confirmation');
  return {
    password: state.password,
    changePasswordForm: {
      oldPassword,
      newPassword,
      confirmation,
    }
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    dialogActions: bindActionCreators(DialogActions, dispatch),
    passwordActions: bindActionCreators(PasswordActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePasswordForm as any);



// WEBPACK FOOTER //
// ./src/containers/ChangePasswordForm.tsx